function bfcmCardValue(card, key) {
  return parseFloat(card.getAttribute('data-' + key)) || 0;
}

// Featured: the admin order of the active chip's collection (data-positions "c1:0 c3:4"),
// on "All" the collections one after another in block order (data-featured)
function bfcmFeaturedValue(card, cat) {
  if (cat === 'all') return bfcmCardValue(card, 'featured');
  var match = (' ' + card.getAttribute('data-positions')).match(new RegExp(' ' + cat + ':(\\d+)'));
  return match ? parseInt(match[1], 10) : 99999;
}

function sortBfcmGrids(mode) {
  $('.bfcm-grid').each(function () {
    var cards = $(this).children('.bfcm-card').get();
    var cat = this.getAttribute('data-active');

    // the server renders "Featured" on All; data-order (that position) breaks ties
    cards.sort(function (a, b) {
      var diff = 0;
      if (mode === 'featured') diff = bfcmFeaturedValue(a, cat) - bfcmFeaturedValue(b, cat);
      else if (mode === 'saving') diff = bfcmCardValue(b, 'save') - bfcmCardValue(a, 'save');
      else if (mode === 'price-asc') diff = bfcmCardValue(a, 'price') - bfcmCardValue(b, 'price');
      else if (mode === 'price-desc') diff = bfcmCardValue(b, 'price') - bfcmCardValue(a, 'price');
      else if (mode === 'rating') diff = bfcmCardValue(b, 'rating') - bfcmCardValue(a, 'rating') || bfcmCardValue(b, 'reviews') - bfcmCardValue(a, 'reviews');
      return diff || bfcmCardValue(a, 'order') - bfcmCardValue(b, 'order');
    });

    $(this).append(cards);
  });
}

// $swatch = swatch to show, or an empty set to go back to the product image
function showBfcmCardImage($card, $swatch) {
  var img = $card.find('.bfcm-card__image')[0];
  if (!img) return;
  if (!img.hasAttribute('data-original-src')) {
    img.setAttribute('data-original-src', img.getAttribute('src'));
    img.setAttribute('data-original-srcset', img.getAttribute('srcset') || '');
  }

  if ($swatch.length) {
    img.srcset = $swatch.attr('data-srcset') || '';
    img.src = $swatch.attr('data-img');
  } else {
    img.srcset = img.getAttribute('data-original-srcset');
    img.src = img.getAttribute('data-original-src');
  }
}

// Loads (and decodes) the swatch images with the card's srcset/sizes, so the swap uses the cached file
function preloadBfcmSwatches(card) {
  if (card.hasAttribute('data-swatches-preloaded')) return;
  card.setAttribute('data-swatches-preloaded', '');

  var sizes = $(card).find('.bfcm-card__image').attr('sizes') || '';
  $(card).find('.bfcm-card__swatch[data-img]').each(function () {
    var img = new Image();
    img.sizes = sizes;
    img.srcset = this.getAttribute('data-srcset') || '';
    img.src = this.getAttribute('data-img');
    if (img.decode) img.decode().catch(function () {});
  });
}

// After the page has loaded, preload swatches only for cards near the viewport
function initBfcmSwatchPreload() {
  if (navigator.connection && navigator.connection.saveData) return;

  var cards = $('.bfcm-card:has(.bfcm-card__swatch[data-img])').get();
  if (!cards.length) return;

  if (!('IntersectionObserver' in window)) {
    cards.forEach(preloadBfcmSwatches);
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      preloadBfcmSwatches(entry.target);
    });
  }, { rootMargin: '300px 0px' });

  cards.forEach(function (card) {
    observer.observe(card);
  });
}

var bfcmCanHover = window.matchMedia('(hover: hover)').matches;

$(document).on('mouseenter', '.bfcm-card', function () {
  if (bfcmCanHover) preloadBfcmSwatches(this);
});

$(document).on('click', '.bfcm-card__swatch[data-img]', function () {
  var $swatch = $(this);
  $swatch.siblings('.bfcm-card__swatch').removeClass('is-active');
  $swatch.addClass('is-active');
  showBfcmCardImage($swatch.closest('.bfcm-card'), $swatch);
});

$(window).on('load', function () {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(initBfcmSwatchPreload, { timeout: 2000 });
  } else {
    setTimeout(initBfcmSwatchPreload, 200);
  }
});

$(document).ready(function () {
  var $select = $('.bfcm-sort__select');
  if (!$select.length) return;

  // the server order is right for "All" and the first chip; another chip open by default needs its own order
  sortBfcmGrids('featured');

  $('.bfcm-grid').each(function () {
    $(this).children('.bfcm-card').each(function (i) {
      this.setAttribute('data-order', i);
    });
  });

  $select.on('change', function () {
    $(this).siblings('.bfcm-sort__value').text($(this).find('option:selected').text());
    sortBfcmGrids($(this).val());
  });

  // Featured follows the chip's collection, so a chip change re-sorts (the inline chip handler runs first)
  $('.bfcm-filters__chips').on('click', '.bfcm-chip', function () {
    if ($select.val() === 'featured') sortBfcmGrids('featured');
  });
});
